/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ClassUtils } from "abweb/utils/ClassUtils";

/**
 * First, everyone should throw Error as it records the stack trace (useful for diagnostics).
 * However, third party libs can (and do) throw anything they like (commonly throw strings), so this
 * class is responsible for converting thrown non-errors to a WrappedError instance so that
 * downstream processing of the thrown object can consistently expect Error.
 */
export class WrappedError extends Error {
  // CAT-842
  static errorFactory(untypedError) {
    if (ClassUtils.isInstanceOf(untypedError, Error)) {
      return untypedError;
    }

    // If it is invoked, use builtin 'toString' representation to try and get meaningful information
    // for the thrown object.

    // Future enhancement: better 'toString' support for 'any' so that arrays and maps display nicely, and
    // guard against circular references via depth count limit
    // (possibly helpful: see code relating to Jasmine.MAX_PRETTY_PRINT_DEPTH which
    // tries to 'toString' 'any' instances that fail in 'expect' statements).
    return new WrappedError(untypedError, `WrappedError instance for underlying thrown value: ${untypedError}`);
  }
  constructor(underlyingError, msg) {
    super(msg);
    this.underlyingError = underlyingError;
  }
}
//# sourceMappingURL=WrappedError.js.map
